<template>
    <div>
<!--    <div class="row row-cols-1 mt-4">-->
<!--        <div class="col">-->
        <strong class="text-muted"><i class="fa-solid fa-lock"></i> Trade Protection™</strong>
        <div class="d-grid grid-0">
            <button
                class="btn"
                :class="[trade.actionNeeded ? ['btn-warning', 'shadow'] : 'btn-outline-secondary']"
                data-bs-toggle="modal" :data-bs-target="'#tp-' + trade.id">
                status:
                <strong v-if="trade.actionNeeded">ACTION REQUIRED</strong>
                <strong v-else>{{ trade.status.toUpperCase() }}</strong>

                <small class="d-block">click for more details</small>
            </button>
        </div>
<!--        </div>-->

        <div class="modal fade" :id="'tp-' + trade.id" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Trade Protection™ <small>(Trade ID: {{ trade.id }})</small></h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="trade.status === 'confirm'">
                            <div v-if="trade.receiving.condition === 'verified'" class="alert alert-success"><i class="fa-solid fa-circle-check"></i> Pin & Pop have graded this pin's condition as: <strong>VERIFIED</strong></div>
                            <div v-else class="alert alert-warning"><p><i class="fa-solid fa-triangle-exclamation"></i> Pin & Pop have graded this pin's condition as: <strong>{{ trade.receiving.condition.toUpperCase() }}</strong></p>
                                You will be contacted via email with additional details.</div>
                            <div class="mt-3">Click each image to view more detail...</div>
                            <a v-for="pic in trade.receiving.images" :key="pic.id" :href="'https://pinandpop.s3.amazonaws.com/' + pic.path + 'pins/' + pic.name" target="_blank">
                                <picture>
                                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + pic.thumbs.webp" type="image/webp">
                                    <source :srcset="'https://pinandpop.s3.amazonaws.com' + pic.thumbs.jpg" type="image/jpeg">
                                    <img class="" :src="'https://pinandpop.s3.amazonaws.com' + pic.thumbs.jpg" :alt="trade[trade.primary].name">
                                </picture></a>
                        </div>
                        <div v-else>
                            <ul class="list-group">
                                <li class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> Accepted Trade</span> <strong>{{ trade.history.created }}</strong></li>

                            <template v-if="trade.protection.length">
                                <li v-if="trade.history.secondary_received" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&P Received Your Pin</span> <strong>{{ trade.history.secondary_received }}</strong></li>
                                <li v-else-if="trade.history.secondary_inbound" class="list-group-item list-group-item-warning"><i class="fa-regular fa-square"></i> Waiting to receive pin from you
                                    <div v-if="trade.shipping.inbound_tracking" class="small">
                                        Tracking:
                                        <a v-if="trade.shipping.inbound_tracking.replace(/[^\d]+/g, '').length > 6" :href="'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + trade.shipping.inbound_tracking" target="_blank">{{ trade.shipping.inbound_tracking }}</a>
                                        <span v-else>{{ trade.shipping.inbound_tracking }}</span>
                                    </div>
                                </li>
                                <li v-else class="list-group-item list-group-item-warning"><i class="fa-regular fa-square"></i> Ship Your Pin To:
                                    <div class="my-2 px-4 py-2 bg-light">
                                        <div>Pin & Pop</div>
                                        <div>{{ shipping.address }}</div>
                                        <div v-if="shipping.address_2">{{ shipping.address_2 }}</div>
                                        <div>{{ shipping.city }} {{ shipping.state }}, {{ shipping.zip }}</div>
                                        <div v-if="shipping.country">{{ shipping.country }}</div>
                                    </div>
                                    <label :for="'tracking-for-' + trade.shipping.id" class="form-label small mt-2 mb-0 d-block">
                                        Shipping Tracking:
                                        <strong v-if="trackingError" class="text-danger ms-2">Enter Tracking Number</strong>
                                    </label>
                                    <div class="input-group">
                                        <input type="text" class="form-control data-hj-allow" :id="'tracking-for-' + trade.shipping.id" placeholder="Enter Tracking Number" v-model="trade.shipping.inbound_tracking">
                                        <button @click="shippedMyPin" type="button" class="btn btn-dark btn-sm">SAVE</button>
                                    </div>
                                </li>
                                <li v-if="trade.history.secondary_received && trade.history.secondary_inspected" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.shipping.condition === 'scrapper' ? 'list-group-item-warning' : 'list-group-item-success']"><span><i class="fa-regular fa-square-check"></i> P&P Inspected Your Pin</span> <strong>{{ trade.history.secondary_inspected }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&P Inspects Your Pin</li>
                                <li v-if="trade.history.primary_response" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.receiving.response === 'approved' ? 'list-group-item-success' : 'list-group-item-danger']">
                                    <span><i class="fa-regular" :class="[trade.receiving.response === 'approved' ? 'fa-check-square' : 'fa-window-close']"></i> You <strong>{{ trade.receiving.response.toUpperCase() }}</strong> the trade</span>
                                    <strong>{{ trade.history.primary_response }}</strong>
                                </li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> You Confirm Trade</li>

                                <li v-if="trade.history.primary_received" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&P Received Trader Pin</span> <strong>{{ trade.history.primary_received }}</strong></li>
                                <li v-else class="list-group-item list-group-item-warning"><i class="fa-regular fa-square"></i> Waiting to receive pin from trader</li>
                                <li v-if="trade.history.primary_received && trade.history.primary_inspected" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.receiving.condition === 'verified' ? 'list-group-item-success' : 'list-group-item-warning']"><span><i class="fa-regular fa-square-check"></i> P&P Inspected Trader Pin: <strong>{{ trade.receiving.condition.toUpperCase() }}</strong></span> <strong>{{ trade.history.primary_inspected }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&P Inspects Trader Pin</li>
                                <li v-if="trade.history.secondary_response" class="list-group-item d-flex justify-content-between align-items-center" :class="[trade.shipping.response === 'approved' ? 'list-group-item-success' : 'list-group-item-danger']">
                                    <span><i class="fa-regular" :class="[trade.receiving.response === 'approved' ? 'fa-check-square' : 'fa-window-close']"></i> Trader <strong>{{ trade.shipping.response.toUpperCase() }}</strong> the trade</span>
                                    <strong>{{ trade.history.secondary_response }}</strong>
                                </li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> Trader Confirms Trade</li>

                                <template v-if="trade.shipping.response === 'rejected' || trade.receiving.response === 'rejected'">
                                <li v-if="trade.history.secondary_shipped" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&P Shipped Original Pin</span> <strong>{{ trade.history.secondary_shipped }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&P Ships Original Pin</li>
                                <li v-if="trade.shipping.shipping_tracking" class="list-group-item text-center">Shipping Tracking:
                                    <h3>
                                        <a v-if="trade.shipping.shipping_tracking.replace(/[^\d]+/g, '').length > 6" :href="'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + trade.shipping.shipping_tracking" target="_blank">{{ trade.shipping.shipping_tracking }}</a>
                                        <span v-else>{{ trade.shipping.shipping_tracking }}</span>
                                    </h3>
                                </li>
                                </template>
                                <template v-else>
                                <li v-if="trade.history.primary_shipped" class="list-group-item list-group-item-success d-flex justify-content-between align-items-center"><span><i class="fa-regular fa-square-check"></i> P&P Shipped New Pin</span> <strong>{{ trade.history.primary_shipped }}</strong></li>
                                <li v-else class="list-group-item text-muted"><i class="fa-regular fa-square"></i> P&P Ships New Pin</li>
                                <li v-if="trade.receiving.shipping_tracking" class="list-group-item text-center">Shipping Tracking:
                                    <h3>
                                        <a v-if="trade.receiving.shipping_tracking.replace(/[^\d]+/g, '').length > 6" :href="'https://tools.usps.com/go/TrackConfirmAction?qtc_tLabels1=' + trade.receiving.shipping_tracking" target="_blank">{{ trade.receiving.shipping_tracking }}</a>
                                        <span v-else>{{ trade.receiving.shipping_tracking }}</span>
                                    </h3>
                                </li>
                                </template>
                            </template>

                            </ul>
                            <!-- <div v-if="!trade.protection.length" class="alert alert-info mt-3">Additional details are not <span v-if="trade.id > 150">yet</span> available for this trade.</div> -->
                            <div v-if="!trade.protection.length" class="alert alert-info mt-3">Additional details are not available for this trade.</div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-link me-auto" data-bs-dismiss="modal">Close</button>
                        <span v-if="trade.status === 'confirm'">
                            <button type="button" @click="rejectTrade" class="btn btn-danger me-3">Reject Trade</button>
                            <button type="button" @click="approveTrade" class="btn btn-success">Approve Trade</button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TradeProtection",
    props: ['tradedata', 'shipping'],
    data() {
        return {
            trade: Vue.util.extend({}, this.tradedata),
            trackingError: false,
            confirmResponse: false
        }
    },
    methods: {
        shippedMyPin: function() {
            let now = new Date().toISOString().substring(0, 10);
            let tracking = this.trade.shipping.inbound_tracking;
            this.trackingError = false;

            if (tracking) {
                axios.put( '/my/trades/' + this.trade.id, {
                    trade_protection_id: this.trade.shipping.id,
                    tracking: this.trade.shipping.inbound_tracking
                }).then(response => {
                    if (response.status === 200) {
                        this.trade.history.secondary_inbound = now;
                        // if (!this.trade.receiving.shipped_at) {
                            this.trade.actionNeeded = false;
                        // }
                    }
                });
            } else {
                this.trackingError = true;
            }
        },
        approveTrade: function() {
            if (confirm('Are you sure you want to APPROVE the trade?')) {
                axios.put( '/my/trades/' + this.trade.id, {
                    trade_protection_id: this.trade.receiving.id,
                    response: 'approved'
                }).then(response => {
                    if (response.status === 200) {
                        this.setTradeConfirm('approved');
                    }
                });
            }
        },
        rejectTrade: function() {
            if (confirm('Are you sure you want to REJECT the trade?')) {
                axios.put( '/my/trades/' + this.trade.id, {
                    trade_protection_id: this.trade.receiving.id,
                    response: 'rejected'
                }).then(response => {
                    if (response.status === 200) {
                        this.setTradeConfirm('rejected');
                    }
                });
            }
        },
        setTradeConfirm: function(response) {
            let now = new Date().toISOString().substring(0, 10);
            this.trade.status = 'processing';
            this.trade.actionNeeded = false;
            this.trade.history.primary_response = now;
            this.trade.receiving.response_at = now;
            this.trade.receiving.response = response;
        }
    },
    mounted() {
        if (this.trade.receiving && this.trade.receiving.images) {
            this.trade.receiving.images = this.trade.receiving.images.sort((a, b) => b.is_primary - a.is_primary);
        }
    }
}
</script>
